/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SubscriptionResponseDto
 */
export interface SubscriptionResponseDto {
    /**
     * Unique identifier for the subscription record
     * @type {string}
     * @memberof SubscriptionResponseDto
     */
    'id': string;
    /**
     * Shop ID associated with the subscription
     * @type {string}
     * @memberof SubscriptionResponseDto
     */
    'shopId': string;
    /**
     * Shopify AppSubscription ID
     * @type {string}
     * @memberof SubscriptionResponseDto
     */
    'subscriptionId': string;
    /**
     * Shopify AppSubscriptionLineItem ID for usage-based pricing
     * @type {string}
     * @memberof SubscriptionResponseDto
     */
    'subscriptionLineItemId': string;
    /**
     * Pricing tier
     * @type {string}
     * @memberof SubscriptionResponseDto
     */
    'tier': SubscriptionResponseDtoTierEnum;
    /**
     * Subscription status
     * @type {string}
     * @memberof SubscriptionResponseDto
     */
    'status': SubscriptionResponseDtoStatusEnum;
    /**
     * Start of the current billing period
     * @type {string}
     * @memberof SubscriptionResponseDto
     */
    'currentPeriodStart': string;
    /**
     * End of the current billing period
     * @type {string}
     * @memberof SubscriptionResponseDto
     */
    'currentPeriodEnd': string;
    /**
     * Start of the trial period (if applicable)
     * @type {string}
     * @memberof SubscriptionResponseDto
     */
    'trialStart'?: string;
    /**
     * End of the trial period (if applicable)
     * @type {string}
     * @memberof SubscriptionResponseDto
     */
    'trialEnd'?: string;
    /**
     * Whether the subscription is currently in a trial period
     * @type {boolean}
     * @memberof SubscriptionResponseDto
     */
    'isInTrial': boolean;
    /**
     * Tier of an in-flight tier-change attempt that the merchant has not yet approved on Shopify. When set, the live tier (`tier` field) remains in effect until Shopify activates the new sub.
     * @type {string}
     * @memberof SubscriptionResponseDto
     */
    'pendingTier'?: SubscriptionResponseDtoPendingTierEnum;
    /**
     * When an unapproved tier-change attempt was created. Used to drive self-healing reconciliation when webhooks are missed.
     * @type {string}
     * @memberof SubscriptionResponseDto
     */
    'pendingCreatedAt'?: string;
    /**
     * When the subscription record was created
     * @type {string}
     * @memberof SubscriptionResponseDto
     */
    'createdAt': string;
    /**
     * When the subscription record was last updated
     * @type {string}
     * @memberof SubscriptionResponseDto
     */
    'updatedAt': string;
}

/**
    * @export
    * @enum {string}
    */
export enum SubscriptionResponseDtoTierEnum {
    Starter = 'STARTER',
    Professional = 'PROFESSIONAL',
    Business = 'BUSINESS',
    Enterprise = 'ENTERPRISE'
}
/**
    * @export
    * @enum {string}
    */
export enum SubscriptionResponseDtoStatusEnum {
    Pending = 'PENDING',
    Active = 'ACTIVE',
    Cancelled = 'CANCELLED',
    Declined = 'DECLINED',
    Expired = 'EXPIRED',
    Frozen = 'FROZEN'
}
/**
    * @export
    * @enum {string}
    */
export enum SubscriptionResponseDtoPendingTierEnum {
    Starter = 'STARTER',
    Professional = 'PROFESSIONAL',
    Business = 'BUSINESS',
    Enterprise = 'ENTERPRISE'
}


